import { createSelector } from 'reselect';
import { selectAllQueryParams } from '../../selectors/routing';

export default createSelector(
  [selectAllQueryParams(['username'])],
  ([username]) => ({ username }),
);
